import "./src/styles/index.scss"
import WithContext from "./WrapRootElement"
import WithAnimationAndCookies from "./WrapPageElement"

export const wrapRootElement = WithContext
export const wrapPageElement = WithAnimationAndCookies

